// Components
import SimpleTable from '../SimpleTable/SimpleTable';

/**
 * DetailHeaderTable component - Renders a simple table for detail header
 * Wrapper around SimpleTable with dark variant configuration
 * @param {object} props - Component props
 * @param {ApiDetailHeaderFieldTableTable} props.table - Table data
 * @returns {JSX.Element | null}
 */
function DetailHeaderTable({ table }) {
  return (
    <SimpleTable
      table={table}
      variant="dark"
      showEmptyMessage
    />
  );
}

export default DetailHeaderTable;
